<template>
    <PtIcon icon="SolidInsightsHoneycombmap" class="text-xl" />
</template>

<script lang="ts" setup>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/InsightsHoneycombmap.svg';
</script>
